import React from 'react';
import { IFrontTask } from "../../../../interfaces/ITask";
import { formatDate, getTaskPriority } from "../../../../Utils/taskUtils";

interface TaskGeneralInfoProps {
  task: IFrontTask;
}

const TaskGeneralInfo: React.FC<TaskGeneralInfoProps> = ({ task }) => {
  const infoItems = [
    {
      label: "Estimativa de entrega",
      value: task.finishDate != null ? formatDate(task.finishDate) : "Em Análise",
      icon: "📅"
    },
    {
      label: "Complexidade",
      value: task?.complexity === null || task?.complexity === undefined ? "Não definida" : task.complexity,
      icon: "⚡"
    },
    {
      label: "Prioridade", 
      value: getTaskPriority(task.priority),
      icon: "🔥"
    },
    {
      label: "Versão",
      value: task.versions !== null && task.versions.length > 0 ? task.versions[0] : "Ainda não publicado",
      icon: "🏷️"
    },
    {
      label: "Ticket",
      value: task.ticket || "Não informado",
      icon: "🎫"
    },
    {
      label: "Categoria",
      value: task.category == "bug"
        ? "Correção"
        : task.category == "customization"
          ? "Customização"
          : task.category == "feat"
            ? "Nova implementação"
            : "Não definida",
      icon: "📂"
    }
  ];

  return (
    <div className="task-info-card">
      <h3>📋 Informações Gerais</h3>
      <div className="task-info-grid">
        {infoItems.map((item, index) => (
          <div key={index} className="task-info-item">
            <div className="task-info-icon">{item.icon}</div>
            <div className="task-info-content">
              <div className="task-info-label">{item.label}</div>
              <div className="task-info-value">{item.value}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TaskGeneralInfo; 